var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 84,
    viewBox: "0 0 50 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.333008V25.333H0.0416676L0 25.3747L16.6667 41.9997L0 58.6663L0.0416676 58.708H0V83.6663H50V58.708H49.9583L50 58.6663L33.3333 41.9997L50 25.3747L49.9583 25.333H50V0.333008H0ZM41.6667 60.7497V75.333H8.33333V60.7497L25 44.083L41.6667 60.7497ZM25 39.9163L8.33333 23.2497V8.66634H41.6667V23.2497L25 39.9163Z",
    fill: "url(#paint0_linear_2725_1552)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2725_1552",
    x1: 25,
    y1: 0.333008,
    x2: 25,
    y2: 83.6663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9b99c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d4ed8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.0c6a906932903442c5f346545c91a397.svg";
export { ForwardRef as ReactComponent };